/**
 * Gentle shimmering chime synthesised via Web Audio API.
 * No external file, no network dependency, sub-millisecond to play.
 * Plays a soft layered bell tone (~1.6s, low volume).
 */
let ctx = null;

export function playShimmerChime() {
  try {
    if (typeof window === "undefined") return;
    const AC = window.AudioContext || window.webkitAudioContext;
    if (!AC) return;
    if (!ctx) ctx = new AC();
    // Browsers may start contexts as "suspended" until a user gesture.
    if (ctx.state === "suspended") ctx.resume().catch(() => {});

    const now = ctx.currentTime;
    // Two detuned layers + a soft high sparkle
    const notes = [
      { freq: 880, dur: 1.4, gain: 0.12 },   // A5
      { freq: 1318.51, dur: 1.3, gain: 0.08 }, // E6
      { freq: 1760, dur: 1.0, gain: 0.05 },   // A6 sparkle
    ];

    const master = ctx.createGain();
    master.gain.value = 0.9;
    master.connect(ctx.destination);

    notes.forEach(({ freq, dur, gain }, i) => {
      const osc = ctx.createOscillator();
      const g = ctx.createGain();
      osc.type = i === 2 ? "sine" : "triangle";
      osc.frequency.setValueAtTime(freq, now);
      // subtle vibrato on the primary
      if (i === 0) {
        osc.frequency.linearRampToValueAtTime(freq * 1.003, now + dur * 0.3);
      }
      g.gain.setValueAtTime(0, now);
      g.gain.linearRampToValueAtTime(gain, now + 0.02 + i * 0.04);
      g.gain.exponentialRampToValueAtTime(0.0001, now + dur);
      osc.connect(g).connect(master);
      osc.start(now + i * 0.04);
      osc.stop(now + dur + 0.05);
    });
  } catch (_e) {
    // fail silently; never block the UI
  }
}
